export const maintenanceType = {
	BROKEN: 1,
	JAMMED_LOCKER: 2,
	BATTERY: 3,
	CARD: 7,
	OTHER: 8
};
